import React from "react";
import {BreadCrumbItem} from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import FormSection from "./FormSection";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/servicios",
        label: "Servicio",
    },
    {
        path: "/servicios/guarderia",
        label: "Guardería",
    },
    {
        path: "/editar",
        label: "Editar",
        isActive: true
    }
]

function EditarServicioGuarderia(){
    return (
        <Page title="Edición de servicio de guardería" description="Modificación de planes de guardería." breadCrumbs={breadCrumbs}>
            <FormSection />
        </Page>
    );
}

export default EditarServicioGuarderia;